import './App.css';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Latest from "./pages/Latest/Latest";

function App() {
  return (
    <Router>
      <Header />
      <Route exact path="/" component={Home} />
      <Route exact path="/latest" component={Latest} />
      <Footer />
    </Router>
  );
}

export default App;
